export enum DropdownDataTransformationsFnsEnum {
  BOOKINGS_STATIONS_OPTIONS = "BOOKINGS_STATIONS_OPTIONS",
  PASSENGER_SOURCE_STATION2_OFFICIAL_FILTER = "PASSENGER_SOURCE_STATION2_OFFICIAL_FILTER",
}
